// extracted by mini-css-extract-plugin
module.exports = {"brand":"PortfolioToggle__brand___2n2wg"};